import { Component, Input } from '@angular/core';
import { CardVariant } from '../../enums/card-variant.enum';

@Component({
  selector: 'evsb-base-card-header',
  templateUrl: './base-card-header.component.html',
  styleUrls: ['./base-card-header.component.scss'],
})
export class BaseCardHeaderComponent {
  @Input() label: string;
  @Input() labelFor: string;
  @Input() variant: CardVariant = CardVariant.blank;

  constructor() {}

  public get variantClass(): string {
    switch (this.variant) {
      case CardVariant.blank:
        return 'bg-white rounded-t-xl';
      case CardVariant.light:
        return 'te-bg-gradient-light-r rounded-t-xl';
      case CardVariant.myDrive:
        return 'text-white te-bg-gradient-r rounded-t-xl';
      case CardVariant.blue:
        return 'text-white bg-blue-dark rounded-t-xl';
      case CardVariant.turquoise:
        return 'bg-turquoise rounded-t-xl';
      default:
        return 'default';
    }
  }
}
